<template>
    <div class="verification-box">
        <b-overlay
            opacity="0.75"
            spinner-variant="primary"
            :show="$root.$data.bsLoader"
        >
            <logout/>

            <div class="verify-content">
                <div class="verify-form">
                    <div class="verification text-center">
                        <div class="auth-brand text-center">
                            <div class="auth-logo mb-5">
                <span class="logo-lg">
                  <img
                      :src="$root.serverBasePath + '/strata.png'"
                      alt="Strata Connex"
                      height="49px"
                  />
                </span>
                            </div>
                        </div>

                        <div v-show="!changeNumber">
                            <h4 class="page-title">Verify your Phone</h4>
                            <p>
                                We have sent verification code to
                                <strong>{{
                                        this.formatPhoneForAustralia(
                                            $store.state.authenticatedUserData.user.user_phone
                                        )
                                    }}</strong>. <br> You need to verify code to continue.

                            </p>
                            <!-- <p class="p-3 mb-0">
                              You need to verify code to continue.
                            </p> -->
                            <p class="font-weight-bold btn" @click="changePhoneNumber()">
                                Change Phone Number? Click Here
                            </p>

                            <b-alert
                                class="verify-phone-alert"
                                :show="dismissCountDown"
                                dismissible
                                variant="success"
                                @dismissed="dismissCountDown = 0"
                                @dismiss-count-down="countDownChanged"
                            >
                                <p>The verification phone code has been sent.</p>
                            </b-alert>
                            <b-form>
                                <b-form-group>
                                    <b-input
                                        v-model="form.phone_verification_code"
                                        type="number"
                                        placeholder="Verification Code"
                                    ></b-input>
                                    <has-error
                                        :form="form"
                                        field="phone_verification_code"
                                        style="text-align: left;"
                                    ></has-error>
                                </b-form-group>
                            </b-form>

                            <b-button variant="primary" block @click="checkIfPhoneVerified"
                            >Continue
                            </b-button
                            >
                            <p class="pt-3 pl-4 pr-4 resend" @click="resendVerifyPhone">
                                Resend verification code
                            </p>
                        </div>

                        <div v-show="changeNumber">
                            <h4 class="page-title">Change Your Phone Number</h4>
                            <p class="p-3">
                                Please change your phone number and go back to verify your
                                number.
                            </p>

                            <b-alert
                                v-show="numberChangedSuccess && dismissCountDown"
                                show
                                dismissible
                                variant="success"
                                @dismissed="dismissCountDown=0"
                                @dismiss-count-down="countDownChanged"
                            >
                                <p>
                                    The phone number has been changed and verification phone code
                                    has been sent to this number.
                                </p>
                            </b-alert>
                            <b-form
                                @submit.prevent="submitChangePhoneNumber"
                                @keydown="changePhoneNumberForm.onKeydown($event)"
                            >
                                <b-form-group>
                                    <b-input
                                        @keyup="formatPhone"
                                        v-model="formattedPhone"
                                        type="text"
                                        placeholder="New Phone Number"
                                    ></b-input>
                                    <has-error
                                        :form="changePhoneNumberForm"
                                        field="phone_number"
                                    ></has-error>
                                </b-form-group>
                                <b-row>
                                    <b-col>
                                        <b-button
                                            type="submit"
                                            variant="primary"
                                            :disabled="form.busy"
                                            block
                                        >Submit
                                        </b-button
                                        >
                                    </b-col
                                    >
                                    <b-col>
                                        <b-button variant="outline-primary" block @click="goBack()"
                                        >Go Back
                                        </b-button
                                        >
                                    </b-col
                                    >
                                </b-row>
                            </b-form>
                        </div>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import {Form, HasError} from "vform";
import FooterComponent from "../../pages/includes/FooterComponent.vue";
import phoneNoMixin from "../../mixins/phoneNoMixin.js";
import SwalMixin from "../../mixins/swalMixin";
import axios from 'axios';
import Logout from "../../pages/common/Logout.vue";

Vue.component(HasError.name, HasError);

export default {
    components: {
        FooterComponent,
        HasError,
        phoneNoMixin,
        Logout
    },
    mixins: [phoneNoMixin, SwalMixin],
    data() {
        return {
            form: new Form({
                phone_verification_code: "",
            }),
            changePhoneNumberForm: new Form({
                phone_number: "",
            }),
            formattedPhone: "",
            changeNumber: false,
            numberChangedSuccess: false,


            dismissSecs: 10,
            dismissCountDown: 0
        };
    },
    mounted() {

    },
    methods: {
        resendVerifyPhone() {
            // this.$root.$data.bsLoader = true;
            axios
                .post("api/resendPhoneVerificationCode")
                .then((response) => {
                    this.numberChangedSuccess = true;
                    this.$root.$data.bsLoader = false;
                    this.dismissCountDown = 10;
                })
                .catch((err) => {
                    this.$root.$data.bsLoader = false;
                });
        },
        checkIfPhoneVerified() {
            this.$root.$data.bsLoader = true;
            this.form
                .post("api/getPhoneStatus")
                .then((response) => {
                    if (response.data.phone_verified) {
                        if (
                            !this.$store.state.authenticatedUserData.user.email_verified_at
                        ) {
                            this.$router.push({
                                name: "verify-email",
                            });
                        } else if (
                            this.$store.state.authenticatedUserData.user.role_id == 2
                        ) {
                            this.$router.push({
                                name: "register-manager",
                                params: {step: 1},
                            });
                        } else {
                            this.$router.push({
                                name: "register-contractor",
                                params: {step: 1},
                            });
                        }
                    }
                    this.$root.$data.bsLoader = false;
                })
                .catch((err) => {
                    this.$root.$data.bsLoader = false;
                });
        },
        formatPhone() {
            this.changePhoneNumberForm.phone_number = this.getPhoneDigitsOnly(
                this.formattedPhone
            );
            this.formattedPhone = this.formatPhoneForAustralia(
                this.changePhoneNumberForm.phone_number
            );
        },
        changePhoneNumber() {
            this.changeNumber = true;
            this.numberChangedSuccess = false;
        },
        submitChangePhoneNumber() {
            this.$root.$data.bsLoader = true;
            this.changePhoneNumberForm
                .post("api/changePhoneNumber")
                .then((response) => {
                    this.$store.state.authenticatedUserData.user.user_phone = response.data.phone_number;
                    this.numberChangedSuccess = true;
                    this.changePhoneNumberForm.phone_number = "";
                    this.formattedPhone = "";

                    this.$root.$data.bsLoader = false;
                    this.dismissCountDown = 5;
                })
                .catch((err) => {
                    this.$root.$data.bsLoader = false;
                });
        },
        goBack() {
            // axios.post("whoami").then(response => {
            //   this.$store.state.authenticatedUserData = response.data.vuex_data;
            //   this.changeNumber = false;
            // });
            this.changeNumber = false;
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        }
    },
};
</script>

<style scoped>
@media screen and (max-width: 500px) {
    br {
        display: none;
    }
}
</style>
